import {LogoSvg} from 'shared/ui/logoSvg';
import {
  ConsentArticle,
  ConsentCard,
  ConsentHeader,
  ConsentLead,
  ConsentList,
  ConsentPage,
  ConsentVersion,
} from './styles';

export const PersonalDataConsentPage = () => {
  return (
    <ConsentPage>
      <ConsentCard>
        <ConsentHeader>
          <LogoSvg width={40} height={40} />
          <ConsentVersion>Версия 1.0</ConsentVersion>
        </ConsentHeader>

        <ConsentArticle>
          <h1>Согласие на обработку персональных данных</h1>
          <ConsentLead>
            Настоящим лицо, подтвердившее свое согласие на сайте{' '}
            <a href="https://cifrovoy-uley.ru" target="_blank" rel="noreferrer">
              https://cifrovoy-uley.ru
            </a>{' '}
            (далее - Пользователь, Сервис), дает свое согласие ПАО "Башинформсвязь" (ОГРН
            1020202561686), зарегистрированному по адресу: 450077, Республика Башкортостан, город
            Уфа, ул. Ленина, д. 30 (далее - Оператор), на обработку персональных данных, а именно:
            ФИО, номер телефона, адрес электронной почты, город проживания, дата рождения, в
            соответствии с Федеральным законом Российской Федерации от 27.07.2006 N 152-ФЗ "О
            персональных данных".
          </ConsentLead>

          <p>
            Оператор производит обработку персональных данных Пользователя любыми способами,
            включая, но не ограничиваясь сбором, записью, систематизацией, накоплением, хранением,
            уточнением (обновлением, изменением), использованием, передачей (распространением,
            предоставлением, доступом), обезличиванием, блокированием, удалением, уничтожением
            персональных данных.
          </p>

          <h2>Цели обработки персональных данных</h2>
          <ConsentList>
            <li>
              Для идентификации Пользователя в рамках использования Сервиса, создания личного
              кабинета.
            </li>
            <li>
              Для предоставления Пользователю доступа к персонализированным ресурсам, функционалу и
              материалам Сервиса.
            </li>
            <li>
              Для установления с Пользователем обратной связи, включая направление уведомлений,
              запросов, касающихся использования Сервиса, оказания услуг.
            </li>
            <li>
              Для подтверждения достоверности и полноты персональных данных, предоставленных
              Пользователем, для обеспечения защиты от мошеннических действий.
            </li>
          </ConsentList>

          <h2>Отзыв согласия</h2>
          <p>
            В случае если Пользователь желает отозвать данное согласие на обработку персональных
            данных, он должен направить Оператору письменное заявление об отзыве по адресу:{' '}
            <a href="mailto:ecpp@rostelecom-rb.ru">ecpp@rostelecom-rb.ru</a>.
          </p>
          <p>
            В случае отзыва Пользователем согласия на обработку его персональных данных Оператор
            обязуется прекратить их обработку или обеспечить прекращение такой обработки (если
            обработка персональных данных осуществляется другим лицом, действующим по поручению
            Оператора) и, в случае если сохранение персональных данных более не требуется для целей
            обработки персональных данных, уничтожить персональные данные или обеспечить их
            уничтожение (если обработка персональных данных осуществляется другим лицом, действующим
            по поручению Оператора) в срок, не превышающий 30 дней с даты поступления отзыва.
          </p>
        </ConsentArticle>
      </ConsentCard>
    </ConsentPage>
  );
};
